<template>
  <div class="items">
    <h1>Edit Item</h1>
      <div class="form">
        <div>
          <input type="text" name="orderID" placeholder="Order ID" v-model="orderID">
        </div>
        <div>
          <input type="text" name="typeID" placeholder="Type ID" v-model="typeID">
        </div>
        <div>
          <input type="text" name="groupID" placeholder="Group ID" v-model="groupID">
        </div>
        <div>
          <input type="text" name="fabricID" placeholder="Fabric ID" v-model="fabricID">
        </div>
        <div>
          <input type="text" name="colourID" placeholder="Colour ID" v-model="colourID">
        </div>
        <div>
          <input type="text" name="name" placeholder="Name" v-model="name">
        </div>
        <div>
          <input type="text" name="width" placeholder="Width" v-model="width">
        </div>
        <div>
          <input type="text" name="drop" placeholder="Drop" v-model="drop">
        </div>
        <div>
          <input type="text" name="total" placeholder="Total" v-model="total">
        </div>
        <div>
          <textarea name="notes" placeholder="Notes" v-model="notes"></textarea>
        </div>
        <div>
          <textarea name="variations" placeholder="Variations" v-model="variations"></textarea>
        </div>
        <div>
          <button class="app_item_btn" @click="updateItem">Update</button>
        </div>
      </div>
  </div>
</template>

<script>
import ItemService from '@/services/ItemService'
export default {
  name: 'EditItem',
  data () {
    return {
      orderID: null,
      typeID: null,
      groupID: null,
      fabricID: null,
      colourID: null,
      name: '',
      width: null,
      drop: null,
      total: null,
      notes: '',
      variations: null
    }
  },
  mounted () {
    this.getItem()
  },
  methods: {
    async getItem () {
      const response = await ItemService.getItem({
        id: this.$route.params.id
      })
      this.orderID = response.data.orderID
      this.typeID = response.data.typeID
      this.groupID = response.data.groupID
      this.fabricID = response.data.fabricID
      this.colourID = response.data.colourID
      this.name = response.data.name
      this.width = response.data.width
      this.drop = response.data.drop
      this.total = response.data.total
      this.notes = response.data.notes
      this.variations = response.data.variations
    },
    async updateItem () {
      await ItemService.updateItem({
        id: this.$route.params.id,
        orderID: this.orderID,
        typeID: this.typeID,
        groupID: this.groupID,
        fabricID: this.fabricID,
        colourID: this.colourID,
        name: this.name,
        width: this.width,
        drop: this.drop,
        total: this.total,
        notes: this.notes,
        variations: this.variations
      })
      this.$router.push({ name: 'Items' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/items/EditItem.vue